<template>
    <div v-show="false">
        <input id="upload-img" ref="upload">
    </div>
</template>

<script type="es6">
    import { mapState, mapActions, mapGetters } from 'vuex'
    import { util } from '../service/util'
    import { commTools } from '../service/commTools'

    let API = util.api([
            'UPLOAD'
        ])

    export default {
        name:'sd-upload',
        props: [],
        data () {
            return {
                
            }
        },
        computed: {
            
        },
        methods: {
            doUpload() {
                $('#uploadifive-upload-img').find('input:last').click();
            },
            init() {
                let _this = this;
                commTools.initUpload($(this.$refs.upload), {
                    fileType: '.jpg,.png',
                    fileSizeLimit: 50000,
                    'uploadScript': API.UPLOAD+';jsessionid='+window.USERINFO.sessionId,
                    onUploadComplete: (file, _data) => {
                        let data = eval('(' + _data + ')');
                        if(data.status == 4){
                            let auth = require('../service/auth.js').auth;
                            auth.pop_login();
                        }
                        _this.$emit('on-upload',data, file);
                    },
                })
            }
        },
        mounted() {
            if(!window.USERINFO){
                this.$store.dispatch('getUserInfo')
                .then( res => {
                    this.init();
                })
            } else {
                this.init();
            }
            
        },
        created(){
            
        }
    }
</script>

<style lang="scss">
  
</style>


// WEBPACK FOOTER //
// sdUpload.vue?f8497060